import React from 'react';
import * as Indicadores from '../../constantes/IndicadoresTitulosEquipos.js';

const CampoComboTitulo = (props) => {
  const estilo = props.estilo;
  const editar = props.editar;
  const nombre = props.nombre;
  const valor = props.valor;

  const onChangeHandler = (event) => {
    const newValue = event.target.value === '' ? null : event.target.value;
    props.onChange(nombre, newValue);
  };

  const opciones = [
    { value: '', label: '-' },
    { value: Indicadores.CAMPEON, label: 'Camp' },
    { value: Indicadores.CAMPEON_COMPARTIDO, label: 'C.Comp' },
    { value: Indicadores.SUBCAMPEON, label: 'SubCamp' },
    { value: Indicadores.MEDALLA_ORO, label: 'Oro' },
    { value: Indicadores.MEDALLA_PLATA, label: 'Plata' },
    { value: Indicadores.MEDALLA_BRONCE, label: 'Bronce' },
  ];

  if (editar) {
    return (
      <select className={`${estilo}`} value={valor || ''} onChange={onChangeHandler}>
        {opciones.map((opcion) => (
          <option key={opcion.value} value={opcion.value}>
            {opcion.label}
          </option>
        ))}
      </select>
    );
  } else {
    const opcionSeleccionada = opciones.find((o) => o.value === valor);
    return <span>{opcionSeleccionada ? opcionSeleccionada.label : ''}</span>;
  }
};

export default CampoComboTitulo;
